<template>
    <div>
      <div class="header_index_nav">
        <header>
          <div class="index_nav_white top">
            <div class="nav_box">
              <div class="nav_flex">
                <div class="nav_logo_b" @click="toMain"></div>
                <div class="nav_li">
                  <div class="nav_li_text" @click="headerClick('aboutus')">关于我们</div>
                  <div class="nav_li_text" @click="headerClick('society')">社会责任</div>
                  <div class="nav_li_text" @click="headerClick('news')">新闻动态</div>
                  <div class="nav_li_text" @click="headerClick('InvestorRelations')">投资者关系</div>
                  <div class="nav_li_text" @click="headerClick('joinUs')">加入我们</div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
      <main class="index_main_content" ref="parentDiv">
        <div class="news_content_box">
          <div class="news_word_title">{{detailData.title}}</div>
          <div class="news_date">{{detailData.createDate}}</div>
          <div class="news_content" v-html="detailData.content">
            
          </div>
        </div>
  
      </main>
      <footer-build @gotoBody="gotoBody"></footer-build>
      
      
    </div>
  </template>
  <script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import UtilEvent from '../utils/UtilEvent.js'
  export default {
    name: 'newsDetail',
    props: ['detailId'],
    components:{UtilEvent},
    data(){
      return{
        detailData:{},
      }
    },
    methods:{
      ...mapActions("global", ["ActionSetCurrentTap"]),
      gotoBody(){
        this.$refs.parentDiv.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      toMain(){
        // this.ActionSetCurrentTap('');
        this.$router.push({name:'main'})
      },
      headerClick(pageName){
        this.ActionSetCurrentTap(pageName);
        this.$router.push(pageName);
      },
      getDetailData(){
        let that = this;
        new UtilEvent().getNewsDetail(this);
        
      },
    },
    mounted(){
      this.getDetailData()
    }
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="less"> 

  </style>
  